import React from "react";
import CommonCaseCard from "../../components/CommonCaseCard/CommonCaseCard";
import { SUBMITTED_CASE_DETAILS } from "../../constants/pathConstants";
import "./CaseCard.css";
import calendarClock from "./calendarClock.svg";
import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";

const CaseCard = ({ selectCards, showCaseType }) => {
  return (
    <div>
      {selectCards &&
        selectCards?.map((item, index) => {
          // Clone the item array to avoid mutating props
          const cardDetail = item.map(field => {
            if (field.label === "Submitted Date" && field.value) {
              const date = new Date(field.value);
              const formatted = `${String(date.getDate()).padStart(2, "0")}/${String(
                date.getMonth() + 1
              ).padStart(2, "0")}/${date.getFullYear()}`;
              return { ...field, value: formatted };
            }
            return field;
          });

          // Extract the formatted date for top badge (after update)
          const submittedField = cardDetail.find((i) => i.label === "Submitted Date");
          const formattedSubmittedDate = submittedField?.value || "-";

          return (
            <div key={`submittedCaseCard-${index}`} className="case-card-wrapper">
              <CommonCaseCard
                cardDetail={cardDetail}
                btn={true}
                showCaseType={showCaseType || false}
                path={SUBMITTED_CASE_DETAILS}
                caseType={"Submitted"}
                formattedSubmittedDate={formattedSubmittedDate}
              />
            </div>
          );
        })}
    </div>
  );
};

const mapStateToProps = createStructuredSelector({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(CaseCard);
